import { render } from "./EmployeeUpdatePhoto.vue?vue&type=template&id=a2c7d85c&scoped=true"
import script from "./EmployeeUpdatePhoto.vue?vue&type=script&lang=js"
export * from "./EmployeeUpdatePhoto.vue?vue&type=script&lang=js"

import "./EmployeeUpdatePhoto.vue?vue&type=style&index=0&id=a2c7d85c&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2c7d85c"]])

export default __exports__